import { render } from "./BagV2.vue?vue&type=template&id=10aaa8e0&scoped=true"
import script from "./BagV2.vue?vue&type=script&lang=js"
export * from "./BagV2.vue?vue&type=script&lang=js"

import "./BagV2.vue?vue&type=style&index=0&id=10aaa8e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aaa8e0"]])

export default __exports__